import { useContext } from 'react';

import { Context } from './AdminMessagesContext';

const useAdminMessagesContext = () => useContext(Context);

export default useAdminMessagesContext;
